var _rect, _g, _circle, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColdCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3259_17148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3259_17148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 44C15.4333 44 14.958 43.808 14.574 43.424C14.1913 43.0413 14 42.5667 14 42V10C14 9.43333 14.1913 8.958 14.574 8.574C14.958 8.19133 15.4333 8 16 8H20V4H28V8H32C32.5667 8 33.0413 8.19133 33.424 8.574C33.808 8.958 34 9.43333 34 10V42C34 42.5667 33.808 43.0413 33.424 43.424C33.0413 43.808 32.5667 44 32 44H16ZM22 40L30 25H26V14L18 29H22V40Z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0399,
    cy: 9.6,
    r: 9.6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3259_17148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 19,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4399,
    width: 18.24,
    height: 18.24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3259_17148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1999 17.1199V13.9659L31.7299 16.3979L30.6659 15.3339L34.1999 11.7999V10.2799H32.6799L29.1459 13.8139L28.0819 12.7499L30.5139 10.2799H27.3599V8.75992H30.5139L28.0819 6.28992L29.1459 5.22592L32.6799 8.75992H34.1999V7.23992L30.6659 3.70592L31.7299 2.64192L34.1999 5.07392V1.91992H35.7199V5.07392L38.1899 2.64192L39.2539 3.70592L35.7199 7.23992V8.75992H37.2399L40.7739 5.22592L41.8379 6.28992L39.4059 8.75992H42.5599V10.2799H39.4059L41.8379 12.7499L40.7739 13.8139L37.2399 10.2799H35.7199V11.7999L39.2539 15.3339L38.1899 16.3979L35.7199 13.9659V17.1199H34.1999Z",
    fill: "#F4C330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdCharging);
export default __webpack_public_path__ + "static/media/ColdCharging.02d85c4b5b46cddc0dc0bf3edd35dc2e.svg";
export { ForwardRef as ReactComponent };